import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ExportCompanyParams,
  ExportCompanyResponse,
  GetCompanyToExportParams,
  GetCompanyToExportResponse,
  GetExportListParams,
  GetExportListResponse,
} from '../types';

export const getExportList = createAsyncThunk<
  GetExportListResponse,
  GetExportListParams
>(
  'export/getExportList',
  async (params: GetExportListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.export, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getCompanyToExport = createAsyncThunk<
  GetCompanyToExportResponse,
  GetCompanyToExportParams
>(
  'export/getCompanyToExport',
  async (params: GetCompanyToExportParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(endPoints.company.index, {
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const exportCompany = createAsyncThunk<
  ExportCompanyResponse,
  ExportCompanyParams
>(
  'export/exportCompany',
  async (params: ExportCompanyParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post(endPoints.export, params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);


export const exportActs = {
  getExportList,
  getCompanyToExport,
  exportCompany,
};
